import type { reportApi } from './report'

export const chefKeys = {
  profile: ['chef', 'profile'] as const,
  score: ['chef', 'average-score'] as const,
  foods: ['chef', 'foods'] as const,
  estimate: ['chef', 'estimate'] as const,
  orders: ['chef', 'orders'] as const,
  shipping: (from: number, to: number) => ['chef', 'shipping', from, to] as const,
  shippingAll: ['chef', 'shipping'] as const,
  comments: ['chef', 'comments'] as const,
  report: (source: keyof typeof reportApi, from: number, to: number) => ['chef', 'report', source, from, to] as const,
}
